export enum ViewOrderProperties {
  deleteDialogWidth = '650px',
  editDialogWidth = '870px',
}
